import { Injectable } from '@angular/core';
import { IUserProfile } from '@services';

@Injectable({
  providedIn: 'root',
})
export class InteractiveWidgetServiceService {
  constructor() {
    // Constructor placeholder
  }

  /**
   * Get Is Firm Allowed for display
   * @param firmNames - Array of strings
   * @param userProfile - User Profile date object
   */
  public getIsFirmAllowed(
    firmNames: Array<string>,
    userProfile: IUserProfile
  ): boolean {
    if (firmNames?.length > 0) {
      return !firmNames.some((firm: string) => {
        const firmName = this.unifyFirmName(firm);
        const profileFirm = this.unifyFirmName(
          userProfile.profileInfo?.firm?.toUpperCase()
        );
        return (
          profileFirm.includes(firmName) ||
          userProfile.profileInfo?.email?.toUpperCase().includes(firmName)
        );
      });
    }
    return true;
  }

  /**
   * Unify FirmName - removes space and dashes, convert to uppercase.
   * @param firmName - string
   */
  private unifyFirmName(firmName): string {
    return firmName.replace(/-/g, '').replace(/ /g, '').toUpperCase();
  }
}
